import { Reducer } from 'redux';
import { LayoutTypes, LayoutState } from './types';

const INITIAL_STATE: LayoutState = {
  visible: false,
};

const reducer: Reducer<LayoutState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // CASES LAYOUT
    case LayoutTypes.SET_LAYOUT_VISIBLE:
      return {
        ...state,
        visible: action.payload.visible,
      };

    default:
      return state;
  }
};

export default reducer;
